export default class GuestMqtt {
    username!: string
    password!: string
    clientId!: string
    topic!: string
}